
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { DateTime } from 'luxon';
import { isDateWithinMaxRange } from '@/utils/timeFunctions';
import DatePicker from '@/components/shared/DatePicker.vue';
import StandardModal from '@/components/shared/suites/StandardModal.vue';

@Component<OrdersReportFiltersModal>({
	components: {
		StandardModal,
		DatePicker
	}
})
export default class OrdersReportFiltersModal extends Vue {
	@Getter('isK12Location', { namespace: 'auth' }) private isK12Location!: boolean;
	@Getter('getTimezone', { namespace: 'auth' }) private timezone!: string;
	@Prop({ type: Boolean, default: false }) private showModal!: boolean;
	@Prop({ type: Boolean, default: false }) private includePrices!: boolean;
	@Prop({ type: Array, default: () => [] }) private dateRange!: string[];

	private mutableIncludePrices: boolean = this.includePrices;
	private mutableDateRange: string[] = [...this.dateRange];

	private get activeFiltersCount(): number {
		return [
			this.mutableIncludePrices,
			this.mutableDateRange.length === 2
		].filter(Boolean).length;
	}

	private get confirmButtonText(): string {
		return this.$t('orders.report.filters_modal.apply_btn') + `${this.activeFiltersCount ? ` (${this.activeFiltersCount})` : ''}`;
	}

	private get maxDate(): string {
		return DateTime.now().setZone(this.timezone).toISODate();
	}

	/**
	 * Apply filters and emit to parent
	 *
	 * @return {void}
	 */
	private applyFilters(): void {
		this.$emit('apply', {
			includePrices: this.mutableIncludePrices,
			dateRange: this.mutableDateRange.length === 2 ? this.mutableDateRange : []
		});
	}

	/**
	 * Reset filters to default values
	 *
	 * @return {void}
	 */
	private resetFilters(): void {
		this.mutableIncludePrices = false;
		this.mutableDateRange = [];
		this.$emit('apply', { includePrices: false, dateRange: [] });
	}

	/**
	 * Filter date picker's dates to allow only dates within the max range if a first date is selected
	 * * Limiting to 7 days for k12 as they have a high amount of orders
	 * * 45 days for non-k12 locations
	 *
	 * @param {string} candidateDate - date to check
	 * @return {boolean}
	 */
	private maxRange(candidateDate: string): boolean {
		const maxDays = this.isK12Location ? 7 : 45;
		return isDateWithinMaxRange(candidateDate, this.mutableDateRange, maxDays);
	}
}
